<template>
  <div class="main">
    <div class="video_box">
      <div v-for="(item,index) in videoList" :key="index" class="video_item">
        <video class="video" :poster="item.file_first" controls="controls">
          <source :src="item.video_url" />
        </video>
        <el-button class="delete_btn" type="primary" @click="deleteItem(item.id)">删除</el-button>
      </div>
    </div>
    <el-form class="form-wrapper padding" ref="addForm" label-width="110px">
      <el-form-item label="视频上传" prop="Video">
        <el-upload
          class="avatar-uploader el-upload--text"
          :action="url_Api+'/hr24_user/v1/upload_file/'"
          :show-file-list="false"
          :on-success="handleVideoSuccess"
          :before-upload="beforeUploadVideo"
          :on-progress="uploadVideoProcess"
        >
          <video
            v-if="videoForm.Video !='' && videoFlag == false"
            :src="videoForm.Video"
            controls="controls"
          >您的浏览器不支持视频播放</video>
          <i
            v-else-if="file_first =='' && videoFlag == false"
            class="el-icon-plus avatar-uploader-icon"
          ></i>
          <el-progress
            v-if="videoFlag == true"
            type="circle"
            :percentage="videoUploadPercent"
            style="margin-top:30px;"
          ></el-progress>
        </el-upload>
        <P class="text">请保证视频格式正确，且不超过10M</P>
      </el-form-item>
      <el-form-item label="图片上传">
        <el-upload
          class="avatar-uploader"
          :action="url_Api+'/hr24_user/v1/upload_file/'"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addvideo">上传</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { require, url_Api } from "@/utils/http_request.js";
export default {
  data() {
    return {
      videoFlag: false,
      videoList: [],
      //是否显示进度条
      videoUploadPercent: "",
      //进度条的进度，
      isShowUploadVideo: false,
      //显示上传按钮
      videoForm: {
        showVideoPath: ""
      },
      file_id: "",
      file_first: "",
      imageUrl: "",
      image_id: "",
      url_Api: ''
    };
  },

  created() {
    this.url_Api = url_Api
    this.list();
  },

  methods: {
    list() {
      let obj = {
        //   token: this.$cookies.get("token")
        show_data:'video'
      };
      require("post", "/hr24_user/v1/share_list/", obj).then(res => {
        if (!res.code) {
          this.videoList = res.data.video_data;
          this.$message({
            message: res.msg,
            type: "success"
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    handleAvatarSuccess(res, file) {
      if (!res.code) {
        console.log(res);
        this.imageUrl = res.data.file_data.file_url;
        this.image_id = res.data.file_data.file_id;
      }
    },

    // 删除视频
    deleteItem(e) {
      let that = this;
      let obj = {
        token: this.$cookies.get("token"),
        poster_id: e
      };
      require("post", "/hr24_user/v1/update_share/", obj).then(res => {
        if (!res.code) {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.list();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    beforeUploadVideo(file) {
      console.log(file);
      var fileSize = file.size / 1024 / 1024 < 50;
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
          "video/mov"
        ].indexOf(file.type) == -1
      ) {
        layer.msg("请上传正确的视频格式");
        return false;
      }
      if (!fileSize) {
        layer.msg("视频大小不能超过50MB");
        return false;
      }
      this.isShowUploadVideo = false;
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },

    //上传成功回调
    handleVideoSuccess(res, file) {
      console.log(res, this.videoForm);
      this.isShowUploadVideo = true;
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      if (!res.code) {
        this.videoForm.showVideoPath = res.data.file_data.file_url;
        this.file_id = res.data.file_data.file_id;
        this.file_url = res.data.file_data.file_url;
        this.$message({
          message: res.msg,
          type: "success"
        });
      } else {
        this.$message.error(res.msg);
      }
    },

    addvideo() {
      console.log(11, this.file_id, this.file_url);
      let obj = {
        token: this.$cookies.get("token"),
        file_id: this.file_id,
        file_first: this.image_id
      };
      require("post", "/hr24_user/v1/add_share/", obj).then(res => {
        if (!res.code) {
          console.log(res);
          this.$message({
            message: res.msg,
            type: "success"
          });

          this.list();
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
.video_box {
  height: 100%;
  width: 100%;
  min-width: 1180px;
  display: flex;
  flex-wrap: wrap;
}

.delete_btn {
  position: absolute;
  bottom: 0;
  width: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  border: 1px solid #ccc;
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.video_item {
  margin: 10px;
  width: 10%;
  min-height: 200px;
  background: beige;
  display: flex;
  flex-direction: column;
  position: relative;
}

.img {
  width: 100%;
}

.video {
  height: 100%;
  width: 100%;
  object-fit: fill;
}
</style>


// WEBPACK FOOTER //
// src/user_management/video_upload.vue